import { render, staticRenderFns } from "./prise_encharge_client.vue?vue&type=template&id=55f3175e&"
import script from "./prise_encharge_client.vue?vue&type=script&lang=js&"
export * from "./prise_encharge_client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports